import React from 'react';
import PropTypes from 'prop-types';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrConnectBankAccountFormStepAccountHolder = ({ formikBag, formFields }) => {
  const _onClickSwitch = () => {
    formikBag.setFieldValue('addressStreetDisplay', null);
    formikBag.setFieldValue('addressStreetNumber', null);
    formikBag.setFieldValue('addressStreetName', null);
    formikBag.setFieldValue('addressCity', null);
    formikBag.setFieldValue('addressStateCode', null);
    formikBag.setFieldValue('addressZip', null);
    formikBag.setFieldValue('locationLatitude', null);
    formikBag.setFieldValue('locationLongitude', null);
    formikBag.setFieldValue('addressUnitNumber', null);
    formikBag.setFieldValue('manualAddressInput', !formikBag.values.manualAddressInput);
  };

  return (
    <>
      <SrCard>
        {formFields.map((formField, index) => (
          <SrBox key={formField.id}>
            <SrFormikField
              formField={formField}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
              margin={index === 0 ? '0px' : null}
            />
          </SrBox>
        ))}
      </SrCard>

      <SrBox marginTop="24px" textAlign="center">
        <SrText
          font="greycliff"
          color="blue300"
          weight="bold"
          cursor="pointer"
          onClick={_onClickSwitch}
        >
          {formikBag.values.manualAddressInput
            ? 'Go back to search the address'
            : 'Can’t find it? Enter address manually'}
        </SrText>
      </SrBox>
    </>
  );
};

SrConnectBankAccountFormStepAccountHolder.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrConnectBankAccountFormStepAccountHolder.displayName = 'SrConnectBankAccountFormStepAccountHolder';

export default SrConnectBankAccountFormStepAccountHolder;
